import { render, staticRenderFns } from "./crearevento.vue?vue&type=template&id=12eed56a"
import script from "./crearevento.vue?vue&type=script&lang=js"
export * from "./crearevento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports